<template>
  <div class="download_area">
    <!-- Download-Free-App-section-Start  -->
    <section class="row_am free_app_section" id="getstarted">
      <!-- container start -->
      <div class="container">
        <div
          class="free_app_inner"
          data-aos="fade-in"
          data-aos-duration="1500"
          data-aos-delay="100"
        >
          <!-- row start -->
          <div class="row">
            <!-- content -->
            <div class="col-md-6">
              <div class="free_text">
                <div class="section_title">
                  <h2>Download Salt Today</h2>
                  <p>
                    Get instant access from the App Store and Google Play and experience stress-free braiding bookings.
                  </p>
                  <h4>Download Now — Free</h4>
                </div>
                <!-- app buttons -->
                <ul class="app_btn">
                  <li>
                    <a href="#" @click.prevent>
                      <img
                        class="blue_img"
                        src="/images/appstore_blue02.png"
                        alt="image"
                      />
                      <img
                        class="white_img"
                        src="/images/appstore_white.png"
                        alt="image"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="#" @click.prevent>
                      <img
                        class="blue_img"
                        src="/images/googleplay_blue02.png"
                        alt="image"
                      />
                      <img
                        class="white_img"
                        src="/images/googleplay_white.png"
                        alt="image"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- images -->
            <div class="col-md-6">
              <div class="free_img">
                <img src="images/download-screen001n.png" alt="image" />
                <img
                  class="mobile_mockup"
                  src="images/download-screen002n.png"
                  alt="image"
                />
              </div>
            </div>
          </div>
          <!-- row end -->
        </div>
      </div>
      <!-- container end -->
    </section>
    <!-- Download-Free-App-section-end  -->
  </div>
</template>

<script>
export default {
  name: "DownloadBox",
};
</script>

<style scoped>
/* hero banner button */
.download_area .app_btn {
  display: flex;
  align-items: center;
  margin: 30px 0;
}

/* hero banner list */
.download_area .app_btn li a {
  display: block;
  padding: 12px 30px;
  background-color: #fff !important;
  border: 2px solid #000 !important;
  position: relative;
  border-radius: 12px;
  transition: 0.4s all;
}

.download_area .app_btn li:last-child {
  margin-left: 25px;
}

.download_area .app_btn li a img {
  transition: 0.4s all;
}

.download_area .app_btn li a .white_img {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
}

.download_area .app_btn li a:hover {
  background-color: #000 !important;
  border: 2px solid #fff !important;
}

.download_area .app_btn li a:hover .blue_img {
  opacity: 0;
}

.download_area .app_btn li a:hover .white_img {
  opacity: 1;
}
.free_text h4{font-weight: 600;
    font-size: 20px;
    color: #d73000;
}


.free_app_section {
    padding-top: 0px; 
     position: relative; 
     padding-bottom: 0px;
    margin-bottom: 200px;
}
</style>

